import React, { Component } from 'react'
import { FormControl, TextField } from '@mui/material'

import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

const KedoMonacoEditor = React.lazy(() =>
    import('../../Editors/KedoMonacoEditor')
)

class DefDossierDefFieldCalcSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            formula: this.props.item?.settings?.formula ?? '',
        }
    }

    render() {
        const { kedo } = this.props
        const { formula } = this.state
        return (
            <div>
                <h5>{this.props.kedo.t('Additional settings')}</h5>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {this.props.kedo.t('Formula')}
                    </FormInputLabel>
                    <KedoMonacoEditor
                        kedo={this.props.kedo}
                        language={'kedoexpr'}
                        originEntity={this.props.defDossier}
                        value={this.state.formula}
                        onChange={(value) => {
                            this.setState({ formula: value })
                            setTimeout(
                                () => this.props.onChange('formula', value),
                                50
                            )
                        }}
                    />
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>Formula</FormInputLabel>
                    <TextField
                        label={kedo.t('Formula')}
                        multiline
                        rows={3}
                        value={formula}
                        onChange={this.handleTextareaChange}
                        fullWidth
                        size="small"
                    />
                </FormControl>
            </div>
        )
    }
}

export default DefDossierDefFieldCalcSettings
